import React from 'react';
import { CheckCircle } from 'lucide-react';
import type { QuizQuestion } from './QuizShell';

interface QuizStepProps {
  question: QuizQuestion;
  selectedPoints: number | null;
  onSelect: (points: number) => void;
}

const QuizStep: React.FC<QuizStepProps> = ({ question, selectedPoints, onSelect }) => {
  return (
    <div>
      {question.introText && (
        <p className="text-gray-600 text-sm italic mb-4 p-3 bg-primary-50 rounded-lg">
          {question.introText}
        </p>
      )}

      <h2 className="text-xl font-heading font-bold text-gray-900 mb-6">
        {question.question}
      </h2>

      <div className="space-y-3">
        {question.options.map((option) => {
          const isSelected = selectedPoints === option.points;
          return (
            <button
              key={option.label}
              onClick={() => onSelect(option.points)}
              className={`w-full p-6 rounded-xl border-2 transition-all text-left cursor-pointer flex items-center justify-between ${
                isSelected
                  ? 'border-accent-600 bg-accent-50'
                  : 'border-gray-200 hover:border-accent-300 hover:shadow-sm'
              }`}
            >
              <div>
                <span className="font-bold text-gray-900">{option.label}</span>
                {option.description && (
                  <p className="text-sm text-gray-500 mt-1">{option.description}</p>
                )}
              </div>
              {isSelected && (
                <CheckCircle className="w-6 h-6 text-accent-600 flex-shrink-0 ml-4" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuizStep;
